import axiosV2, { apiPost } from '../core/http/axios_api_v2';
import { orderContactsBrideFirst, isBrideContact, isGroomContact } from './contactOrdering';
import { orderTotalAfterVat } from '../../../shared/vat.js';
import { billedGuests, guestsWarnings } from '../../../shared/guests.js';
import { normalizeLeadsWidgetSettings, leadsWidgetHides } from './LeadsWidgetSettings';

export default {


    /**
     * Generate a secure access code and URL for the contact form
     * @param {number} contactId - The contact ID
     * @param {number} eventId - The event ID
     * @param {number} tenantId - The tenant ID (optional, will use store if not provided)
     * @returns {Promise<{accessCode: string, url: string}>} The access code and full URL
     */
    async generateContactFormLink(contactId, eventId, tenantId = null) {
        const tenant = tenantId || planup.$store.state.tenantId;
        
        return axiosV2.get(`/customer-contact/generate-token/${tenant}/${contactId}/${eventId}`)
            .then(response => response.data);
    },


    calendarTooltip(eventId) {
        return axiosV2.get(`/event/tooltip/${eventId}`).then(response => {

            let html = `
            
                <div style="text-align: center;color:rgb(119, 119, 119)">
                    ${planup.$globals.niceDate(response.data.date)}

                    ${response.data.time ? ' &nbsp; ' + response.data.time : ''}

                </div>
                <br>

                <div style="font-weight:bold;">

                    ${response.data.name}

                </div>

                <br>
            
            `;






            for (let i = 0; i < response.data?.customer?.contacts?.length; i++) {

                html += `<img class='eventTooltipContactImage' src="${planup.$handlers.customerHandler.getContactImage(response.data.customer.contacts[i])}"> ${response.data.customer.contacts[i].firstName}&nbsp;&nbsp;`

            }

            html += '<br>';
            html += '<br>';


            if (response.data?.eventClass?.name)
                html += 'סוג אירוע: ' + response.data.eventClass.name + '<br>'




            if (response.data?.place?.name)
                html += 'מקום: ' + response.data.place.name + '<br>'


            if (response.data?.estimatedNumberOfGuests)
                html += 'מספר אורחים: ' + response.data.estimatedNumberOfGuests + '<br>'


            // if (response.data?.products?.length) {


            //     html += 'מחיר: ' + (this.sumOfProducts(response.data) * 1.17).format2Digits() + ' ש"ח<br>';

            //     if (response.data.mikdama) {
            //         html += 'סכום מקדמה: ' + response.data.mikdama.format2Digits() + ' ש"ח<br>';
            //     }


            //     html += 'מוצרים:';

            //     response.data.products.forEach(product => {

            //         html += product.name + ' - ' + product.count + ' יחידות';
            //     })

            //     html += '<br>';
            // }


            if (response.data?.crewMembers?.length)
                html += 'צוות: ' + response.data?.crewMembers?.map(c => c.name).join(', ') + '<br>';






            return html;

        })
    },





    validateEvent(component, event) {

        // let eventErrors = {};

        // eventErrors.name = !event.name ? 'שדה חובה' : null;
        // eventErrors.date = !event.date ? 'שדה חובה' : null;
        // eventErrors.eventClass = !event.eventClass ? 'שדה חובה' : null;
        // eventErrors.estimatedNumberOfGuests = !event.estimatedNumberOfGuests ? 'שדה חובה' : null;

        // component.$set(event, 'errors', eventErrors);

    },



    mikdamaPaymentTypeOptions: [
        { name: 'כרטיס אשראי', value: 'ccard' },
        { name: 'מזומן', value: 'cash' },
        { name: "צ'ק", value: 'check' },
        { name: 'העברה בנקאית', value: 'transfer' },
        { name: 'אחר', value: 'other' },
    ],

    productPriceTypeOptions: [
        { name: 'גלובלי', value: 'global' },
        { name: 'לאדם', value: 'perperson' },
        { name: 'כמות מוגדרת', value: 'amount' },
    ],


    // helper functions
    //////////////////////



    generateNewListOfProducts() {


        // if you change this function, pleaes note that there is a copy in imoprt clients service

        return {
            taxDocuments: [],
            actualListOfProducts: [],
            vatPercentDecimal: planup.$globals.vatPercentDecimal(),
            vatPercent: planup.$globals.vatPercent(),
            totalSumBeforeVat: 0,
            totalSumAfterVat: 0,
        }
    },


    generateLocalEmptyEvent(customer, date, time) {

        return {

            customer: customer,
            name: "",
            notes: "",
            place: null,
            time: time,
            eventClass: null,
            products: [
                this.generateNewListOfProducts()
            ],
            crewMembers: [],
            estimatedNumberOfGuests: null,
            finalNumberOfGuests: null,
            minimumGuests: null,
            otherVendors: [],
            time: planup.$store.state.businessSettings.defaultEventTime,

            // dates
            date: date?.getTime?.() ? date : null,
            specificRequestedDates: date?.getTime?.() ? [date] : [],
            requestedDateRange: {},


        }
    },


    // The date the customer asks for, from EventDatePicker's three tabs - the new inquiry form,
    // פרטי האירוע and פרטי העסקה set it the same way: one date, several options (no date until one
    // of them is set) or a range. $set: an event that came without one of these keys must still show it.
    setRequestedSingleDate(event, date) {
        planup.$set(event, 'date', date);
        planup.$set(event, 'specificRequestedDates', [date]);
        planup.$set(event, 'requestedDateRange', {});
        planup.$set(event, 'optionalDatesHoldUntil', null);
    },

    setRequestedOptions(event, dates) {
        planup.$set(event, 'date', null);
        planup.$set(event, 'specificRequestedDates', dates);
        planup.$set(event, 'requestedDateRange', {});
    },

    setRequestedRange(event, rangeStart, rangeEnd, daysOfWeek) {
        planup.$set(event, 'date', null);
        planup.$set(event, 'specificRequestedDates', []);
        planup.$set(event, 'requestedDateRange', { rangeStart, rangeEnd, daysOfWeek });
        planup.$set(event, 'optionalDatesHoldUntil', null);
    },

    // the tabs of an event's date field: options and a range until the order is signed
    requestedDateTabs(event) {
        return event && event.planupSystemStatus == 'hazmanaSigned' ? [1] : [1, 2, 3];
    },


    sumOfProductList(productList,event) {

        let sum = 0;

        productList.forEach(product => {
            sum += this.getSum(product, typeof event === 'number' ? event : billedGuests(event));
        });

        return sum

    },




    // the guest count per-person lines are billed on (shared/guests.js): the minimum once set
    billedGuests(event) {
        return billedGuests(event);
    },

    // the final count below the minimum / above the place's capacity (shared/guests.js)
    guestsWarnings(event) {
        return guestsWarnings(event, event && event.place ? event.place.capacity : null);
    },


    sumOfProducts(event) {

        if (!event)
            return 0;

        let sum = parseInt(billedGuests(event) * event.mealCost);

        if (isNaN(sum))
            sum = 0;


        // orderTotalAfterVat, not order.totalSumAfterVat: on a ללא-מע"מ order the stored field was
        // persisted 18% too high, and the deal total has to read the way the הזמנה itself prints
        event?.products?.forEach(order=> sum += order.markedAsHidden ? 0 : orderTotalAfterVat(order));


        return !isNaN(sum) ? sum : 0;
    },

    sumOfProductsWithoutDiscount(event) {

        if (!event)
            return 0;

        let sum = parseInt(billedGuests(event) * event.mealCost);

        if (isNaN(sum))
            sum = 0;


        event?.products.map(p => {

            if (p.discount)
                return;

            sum += +this.getSum(p, billedGuests(event))
        });



        return !isNaN(sum) ? sum : 0;
    },

    getSum(product, guestCount) {

        if (!product.price)
            return 0;


        if (product.priceType?.value == 'amount') {
            return !isNaN(+product.price * +product.count) ? (+product.price * +product.count) : 0;
        }


        if (product.priceType?.value == 'perperson') {
            return (+product.price * +guestCount);
        }

        return (+product.price);


    },




    mettingIndicatorHTML(date) {


        if (typeof date == 'string')
            date = new Date(date);

        if (!date)
            return '<span style="color: red;">לא נקבעה</span>';


        const today = new Date();
        let giveDateIsToday = date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();

        if (giveDateIsToday)
            return 'נקבעה פגישה להיום';


        if (date.getTime() < new Date().getTime())
            return 'הפגישה עברה';

        return planup.$globals.niceDate(date);

    },




    // סטטוס תשלום state shared by the customer page strip and the /customers table. The
    // full/partial rule mirrors handleEventPaymentIndicator (apiv2): the total is floored,
    // any paid >= floor counts as full. The server-side table filter
    // (search-results.service, 'paymentStatus') mirrors the whole thing — keep them in sync.
    //   noDeal    — nothing priced and nothing paid (no deal entered yet)
    //   notSigned — priced, but no signed order yet (מצב פניה != hazmanaSigned) and nothing
    //               paid: a quote / unsigned order is not a deal, so the payment status is
    //               not relevant yet and the UI shows a placeholder instead of a red 0 מתוך X.
    //               Money that DID come in (a deposit on a quote) is always shown — it's real.
    //   none / partial / full — the usual paid-vs-total comparison (floor rule)
    paymentStatusState(paid, total, planupSystemStatus) {

        paid = +paid || 0;
        total = +total || 0;

        if (!paid && !total)
            return 'noDeal';

        if (!paid && planupSystemStatus != 'hazmanaSigned')
            return 'notSigned';

        if (!paid)
            return 'none';

        return paid >= Math.floor(total) ? 'full' : 'partial';
    },


    // true when the state carries amounts worth displaying (noDeal / notSigned show a placeholder)
    paymentStatusShown(state) {
        return state == 'none' || state == 'partial' || state == 'full';
    },


    // יתרה לתשלום: what the customer still owes on the deal, in whole shekels - 0 when paid up or
    // when no payment status applies yet (a quote / unsigned order with nothing paid). The total is
    // rounded the way search_result stores it, then floored like the paid-in-full rule. Mirrors
    // SearchResultRebuilder.balanceDue / balanceDueSql (apiv2), which the customers-table filter and
    // sort read - keep them in sync.
    balanceDue(total, paid, planupSystemStatus) {

        total = Math.floor(Math.round(+total || 0));
        paid = +paid || 0;

        if (paid >= total)
            return 0;

        if (paid <= 0 && planupSystemStatus != 'hazmanaSigned')
            return 0;

        return Math.round(total - paid);
    },





    hazmanaSignedLabel() {
        let status = planup.$store.state.planupSystemStatuses.find(x => x.value == 'hazmanaSigned');
        return status ? status.label : 'אירוע סגור';
    },


    // מצב פניה as a pill tag — the /customers table look, shared so the customer page
    // renders it identically. Fully inline-styled: .planupTag lives in Customers2's
    // <style>, which isn't loaded on pages that never mount that table.
    systemStatusPillHTML(planupSystemStatus) {

        switch (planupSystemStatus) {

            case 'pniaInTipul':
                return this.statusPillHTML('#fff6e8', '#d18700', '#ffe1ad', 'פניה בטיפול');

            case 'pniaNotRelevant':
                return this.statusPillHTML('#ffecef', '#e63e5c', '#ffc9d3', 'פניה לא רלוונטית');

            case 'priceOfferSent':
                return this.statusPillHTML('#e8f6fd', '#0d8bc7', '#b7e5f8', 'יצאה הצעת מחיר');

            case 'hazmanaSent':
                return this.statusPillHTML('#f1f2f6', '#5a6270', '#d9dce3', 'יצאה הזמנה');

            case 'hazmanaSigned':
                // inventory businesses see הזמנה חתומה — the label lives on the store entry
                return this.statusPillHTML('#f1ebfc', '#7c53d6', '#ddcdf7', this.hazmanaSignedLabel());

            case 'hazmanaCanceled':
                return this.statusPillHTML('#ffecef', '#e63e5c', '#ffc9d3', 'הזמנה מבוטלת');

            default:
                return this.statusPillHTML('#e6f9f3', '#00a67e', '#b3ecd9', 'פניה חדשה');

        }

    },


    statusPillHTML(bg, color, border, text) {
        return `<span class="planupTag" style="display:inline-block;padding:2px 12px;border-radius:999px;`
            + `font-size:12px;font-weight:600;line-height:20px;white-space:nowrap;`
            + `background:${bg};color:${color};border:solid 1px ${border}">${text}</span>`;
    },


    eventStatusIndicatorHTML(planupSystemStatus) {




        switch (planupSystemStatus) {

            case 'pniaInTipul':
                return '<div class="btn btn-warning btn-xs"><i class="fa-regular fa-thumbs-up"></i>&nbsp;פניה בטיפול</div>';

            case 'pniaNotRelevant':
                return '<div class="btn btn-danger btn-xs"><i class="fa-solid fa-ban"></i>&nbsp;פניה לא רלוונטית</div>';

            case 'priceOfferSent':
                return '<div class="btn btn-info btn-xs">יצאה הצעת מחיר</div>';

            case 'hazmanaSent':
                return '<div class="btn btn-secondary btn-xs">יצאה הזמנה </div>';

            case 'hazmanaSigned':
                // label lives on the store entry — inventory businesses see הזמנה חתומה there
                return '<div class="btn btn-primary btn-xs"><i class="fa-solid fa-check"></i>&nbsp;' + this.hazmanaSignedLabel() + '</div>';

            case 'hazmanaCanceled':
                return '<div class="btn btn-danger btn-xs"><i class="fa-solid fa-ban"></i>&nbsp;הזמנה מבוטלת</div>';

            default:
                return '<div class="btn btn-success btn-xs">פניה חדשה</div>';

        }

    },



    prepEventFromServerToVue(eventData) {


        eventData.date = eventData.date ? new Date(eventData.date) : null;


        eventData.mikdamaPaymentType = this.mikdamaPaymentTypeOptions.find(x => x.value == eventData.mikdamaPaymentType);


    },






    buildEventSummaryTextForTimeline(event) {

        let eventSummaryText = '';

        if (event.eventClass) {
            eventSummaryText = event.eventClass.name;

            if (event.place) {
                eventSummaryText += ' ב' + event.place.name;
            }

            if (event.estimatedNumberOfGuests) {
                eventSummaryText += ', ';
            }

        }
        if (event.estimatedNumberOfGuests) {
            eventSummaryText += event.estimatedNumberOfGuests + ' אורחים';
        }

        return eventSummaryText;
    },




    _fixSearchResults() {
        axiosV2.get('/search-results/fixSearchResults');
    },




    // getting functions
    //////////////////////

    async getEvents() {

        return axiosV2("/event").then(

            response => response.data


        );
    },

    async getEvent(id) {

        return axiosV2(`/event/${id}`).then(

            response => response.data


        );
    },





    updateEventName(eventId, newName) {
        return apiPost('event/planupEvent', { id: eventId, name: newName });

    },




    // saving function
    //////////////////////

    // this function is good for general creation and initial changes,
    // saving THE WHOLE EVENT,
    // later we update specific things in the event no?
    async saveEvent(eventData, callback, hideSuccessAlert) {

        setNoon(eventData.date);

        // Only a NEW event without a name gets the default. An EXISTING event never does: its name
        // field passes through the contacts / class watchers (AddEvent, CustomerPage), whose
        // suggestion is '' whenever the class or the contacts are not at hand, and a partial save
        // ({ id, products }) carries no name at all - so an empty name on an update means "nothing
        // to say", not "call it אירוע חדש". No name in the payload leaves the stored one alone
        // (מעין מלכה 3/9: 'השמלת כלה של חן' became 'אירוע חדש' on the way to a חשבונית מס קבלה;
        // 57 such renames across 8 tenants since July, most typed back by hand).
        if (!eventData.name && !eventData.id)
            eventData.name = 'אירוע חדש';


        // quick clone without circular customer
        let eventDataClone;
        if (eventData.customer) {
            let customerBackup = eventData.customer;
            eventData.customer = { id: eventData.customer.id };
            eventDataClone = deepCopy(eventData);
            eventData.customer = customerBackup;
        } else {
            eventDataClone = deepCopy(eventData);
        }

        //// end quick clone

        if (eventDataClone.id && !eventDataClone.name)
            delete eventDataClone.name;



        if (eventDataClone.mikdamaPaymentType?.name) {
            eventDataClone.mikdamaPaymentType = eventDataClone.mikdamaPaymentType.value;
        }





        return apiPost('event/planupEvent', eventDataClone, hideSuccessAlert).then(
            savedEvent => {
                eventData.id = savedEvent.id;

                planup.$handlers.calendarHandler.addItemToCache(eventData.date, 'event', eventData);

                if (callback)
                    callback(savedEvent);
            }
        );
    },



    getHazmana(eventId) {
        return axiosV2(`tax-documents/getHazmana/${eventId}`).then(res => res.data);
    },


    async checkCrewMemberConflicts(eventId, crewMemberIds, eventDate) {
        if (!crewMemberIds || crewMemberIds.length === 0 || !eventDate) {
            return { hasConflicts: false, conflicts: [] };
        }

        return apiPost('event/check-crew-conflicts', {
            eventId: eventId || 0,
            crewMemberIds: crewMemberIds,
            eventDate: eventDate
        }).then(response => response);
    },


    manualSetSigned(event) {
        this.updateStatus(event, 'hazmanaSigned');
    },

    //system status is predefined strings that depict the event's progress
    //status here is string
    updateStatus(event, newSystemStatus, newEventStatus, hideSuccessAlert, ) {

        if (newSystemStatus)
            event.planupSystemStatus = newSystemStatus;

        if (newEventStatus)
            event.planupEventStatus = newEventStatus;

        return apiPost(`event/updateStatus/${event.id}`, { planupSystemStatus: newSystemStatus, planupEventStatus:newEventStatus }, hideSuccessAlert).then(() =>
            planup.$handlers.calendarHandler.hardResetAllCalendars()
        );
    },


    // The one way a status change is applied from a popup - ChangeEventStatus, and "סימון הפניה
    // כלא רלוונטית" in the delete-customer popup: saves it (event/updateStatus also rebuilds the
    // event's search_result row, and the calendars reload), tells any open list to patch its row
    // ($root 'eventStatusUpdated' - the /customers table listens) and patches the dashboard's
    // לידים חדשים rows
    applyStatusChange(event, newSystemStatus, newEventStatus) {

        let saved = this.updateStatus(event, newSystemStatus, newEventStatus);

        planup.$root.$emit('eventStatusUpdated', event);

        this.syncDashboardLeads(event, newEventStatus);

        return saved;
    },


    // the dashboard's לידים חדשים rows come with appData, once per session — patch the row
    // here (its status texts), or drop it once its מצב פניה is one the widget hides, so going
    // back to the dashboard doesn't still show a פנייה that was just marked לא רלוונטית
    syncDashboardLeads(event, newEventStatus) {

        let leads = planup.$store.state.dashboardLeads || [];
        let idx = leads.findIndex(lead => lead.eventId == event.id);

        if (idx < 0)
            return;

        let settings = normalizeLeadsWidgetSettings(planup.$store.state.homepageSettings);

        if (leadsWidgetHides(settings, event.planupSystemStatus)) {
            leads.splice(idx, 1);
            return;
        }

        planup.$set(leads[idx], 'planupSystemStatus', event.planupSystemStatus || null);

        if (newEventStatus && newEventStatus.name)
            planup.$set(leads[idx], 'planupEventStatus', newEventStatus.name);
    },


    // after a canceling status: on to the הזמנת ביטול and / or the קבלה שלילית the user ticked
    continueCancelingProcess(customerId, eventId, makeHazmanatBitul, makeNegativeKabala) {

        if (makeHazmanatBitul && makeNegativeKabala) {
            planup.$router.push(`/createTaxDocument?type=hazmana&customerId=${customerId}&eventId=${eventId}&cancelOrder&makeNegativeKabala`);
            return;
        }

        if (makeHazmanatBitul) {
            planup.$router.push(`/createTaxDocument?type=hazmana&customerId=${customerId}&eventId=${eventId}&cancelOrder`);
            return;
        }

        if (makeNegativeKabala) {
            planup.$router.push(`/createTaxDocument?type=kabala&customerId=${customerId}&eventId=${eventId}&thisNeedsToBeNegative`);
            return;
        }
    },


    //navigation functions
    // goToEvent(event) {
    //     this.$router.push(`/customer/${event.id}`)
    // }


    gotoAddNewEventToCustomer(customer, date) {
        planup.$router.push(`/customer/${customer.id}?newEvent=${date?.getTime() ? date.getTime() : ''}`)
    },


    gotoAddNewEventToCustomerFromSearchResult(searchResult, date, time) {

        let url = `/customer/${searchResult.customerId}?newEvent${date?.getTime() ? `=${date.getTime()}` : ''}`;

        if (time)
            url += `&newEventTime=${time}`;

        planup.$router.push(url)
    },


    suggestNewEventNameFromUpdatedContacts(event) {

        let contacts = event?.customer?.contacts;


        if (!contacts)
            return '';


        if (!event?.eventClass)
            return '';


        if (!contacts[0].firstName)
            return '';

        // Brides (כלה) before grooms (חתן) — shared ordering mechanism, see contactOrdering.js
        let bridesAndGrooms = orderContactsBrideFirst(contacts)
            .filter(contact => isBrideContact(contact) || isGroomContact(contact))
            .map(contact => contact && contact.firstName)
            .join(' ו');


        if (bridesAndGrooms.length){
            return 'ה' + event?.eventClass?.name + ' של ' + bridesAndGrooms;
        }

        switch (true) {

            case contacts.length == 1://only one contact
                return 'ה' + event?.eventClass?.name + ' של ' + contacts[0].firstName;
            case contacts.length > 1://more than 1 contacts
                return 'ה' + event?.eventClass?.name + ' של ' + contacts[0].firstName + ' ו' + contacts[1].firstName;

        }

        return '';


    }



    // setPriceOfferWasSent(event) {
    //     event.priceOfferWasSent = true;
    //     return apiPost(`event/setPriceOfferWasSent/${event.id}`);
    // },




    // setOrderWasMade(event) {
    //     event.orderWasMade = true;
    //     return apiPost(`event/setOrderWasMade/${event.id}`);
    // },




    // setOrderWasSigned(event) {
    //     event.orderWasSigned = true;
    //     return apiPost(`event/setOrderWasSigned/${event.id}`);
    // },








    // statusToHtml(status) {

    //     switch (status) {


    //         case 'newlead':
    //             return '<div class="badge rounded-pill badge-secondary">ליד חדש</div>';

    //         default:
    //             return status;

    //     }

    // }







    //date functions





}